import React, { ReactElement } from 'react';
import { CurrencyValue, formatCurrency } from '../../lib/currency';

interface CurrencyProps {
    value?: CurrencyValue;
    children?: CurrencyValue;
    currencyCode?: string;
}

const Currency = ({ value, children, currencyCode }: CurrencyProps): ReactElement => (
    <>{formatCurrency(value || children || 0, (currencyCode || children) as unknown as string)}</>
);

export default Currency;
